import { useState, useEffect } from 'react';
import { usePropertySelection } from '../../../hooks/usePropertySelection';

export const usePropertyCardLogic = (setPropertyData, isMRV) => {
  const [localLoading, setLocalLoading] = useState(true);

  const propertySelection = usePropertySelection(isMRV);

  const {
    isLoading: apiLoading,
    cities,
    properties,
    units,
    selectedCity,
    selectedProperty,
    selectedUnit,
    propertyValue,
    priceTableVersion,
    address,
    handleCityChange,
    handlePropertyChange,
    handleUnitChange
  } = propertySelection;

  const isLoading = localLoading || apiLoading === true;

  // Atualizar dados para o componente pai
  useEffect(() => {
    if (!setPropertyData) return;

    const city = cities.find(c => c.value === selectedCity);
    const propertyLabel = properties.find(p => p.value === selectedProperty)?.label || '';
    const unity = units.find(u => u.value === selectedUnit);
    
    setPropertyData({
      selectedCity: city?.label || '',
      selectedProperty: propertyLabel,
      selectedUnit: unity?.label || '',
      selectedUnitId: selectedUnit,
      selectedState: city?.state || '',
      commercialTierType: unity?.data?.tipoFaixaComercial || '',
      propertyValue,
      priceTableVersion,
      address,

    });
  }, [
    selectedCity, selectedProperty, selectedUnit,
    propertyValue, priceTableVersion, address,
    setPropertyData
  ]);

  useEffect(() => {
    if (cities.length > 0) {
      setLocalLoading(false);
    }
  }, [cities]);

  return {
    isLoading,
    cities,
    properties,
    units,
    selectedCity,
    selectedProperty,
    selectedUnit,
    propertyValue,
    priceTableVersion,
    address,
    handleCityChange,
    handlePropertyChange,
    handleUnitChange
  };
};